export const selectLikes = (state) => state.likes;
